
// 2. Desktop/DesktopSkillboard.tsx - Performance optimiert
import React, { Suspense, lazy } from "react";
import { Box, Container, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";

// Lazy load heavy components
const LazySkillAchievements = lazy(() => import("./SkillAchievements"));
const LazyLeaderboard = lazy(() => import("./Leaderboard"));
const LazyStreakRanking = lazy(() => import("./StreakRanking"));
const LazySkillboardCourses = lazy(() => import("./SkillboardCourses"));

const DashboardContainer = styled(Container)(({ theme }) => ({
  padding: "2rem",
  backgroundColor: theme.palette.background.default,
  minHeight: "100%",
  marginTop: "5rem",
}));

const SectionHeader = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: "#fff",
  padding: "10px 15px",
  marginBottom: "0.8rem",
  borderRadius: "8px",
  fontWeight: "bold",
  fontSize: "1.2rem",
}));

const LoadingWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={
    <Box display="flex" justifyContent="center" p={4}>
      <CircularProgress />
    </Box>
  }>
    {children}
  </Suspense>
);

const DesktopSkillboard: React.FC = () => {
  console.log("🖥️ Desktop Skillboard rendering...");

  return (
    <DashboardContainer maxWidth="lg" sx={{ background: "#f7f7f7" }}>
      {/* Lernerfolge */}
      <SectionHeader>Lernerfolge</SectionHeader>
      <LoadingWrapper>
        <LazySkillAchievements />
      </LoadingWrapper>

      {/* Rankings */}
      <SectionHeader>Rankings</SectionHeader>
      <Box sx={{ backgroundColor: "#e0e0e0", padding: 3, borderRadius: 3, marginBottom: "1.5rem" }}>
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 3 }}>
          <LoadingWrapper>
            <LazyLeaderboard />
          </LoadingWrapper>
          <LoadingWrapper>
            <LazyStreakRanking />
          </LoadingWrapper>
        </Box>
      </Box>

      {/* Lernkurse */}
      <SectionHeader>Lernkurse</SectionHeader>
      <Box sx={{
        padding: "1.5rem",
        borderRadius: "12px",
        background: "#fff",
        boxShadow: "0px 6px 12px rgba(0,0,0,0.1)",
      }}>
        <LoadingWrapper>
          <LazySkillboardCourses />
        </LoadingWrapper>
      </Box>
    </DashboardContainer>
  );
};

export default DesktopSkillboard;